import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TlTabComponent } from './tl-tab.component';
import { TlTabsComponent } from './tl-tabs.component';



@NgModule({
  declarations: [
    TlTabsComponent,
    TlTabComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    TlTabsComponent,
    TlTabComponent,
  ]
})
export class TlTabsModule { }
